import { useEffect, useMemo, useRef, useState } from "react";
import styles from "./ItemAndStoreDetails.module.scss";
import { TabView, TabPanel } from "primereact/tabview";
import ItemAndStoreSearchScreen from "../../container/Item-Store-Search-Screen/ItemAndStoreSearchScreen";

export default function ItemAndStoreSearch() {
    const [activeIndex, setActiveIndex] = useState(0);
      useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, []);
    return (<>
        <div className="grid ">
            <div className="col-12 ">
                <TabView
                    className={`${styles.noBorderForTab} ${styles.tabViewBotttomBorder}`}
                    activeIndex={activeIndex}
                    onTabChange={(e) => { setActiveIndex(e.index) }}
                >
                    <TabPanel
                        header="Item"
                        headerClassName={`${styles.tabWidth} `}
                        className={`${styles.tab}   ${activeIndex === 0 ? styles.activeTab : styles.InactiveTab
                            }`}
                    >
                        <ItemAndStoreSearchScreen screenName={"Item"} />
                    </TabPanel>
                    <TabPanel
                        header="Store"
                        headerClassName={`${styles.tabWidth} `}
                        className={`${styles.tab} ${activeIndex === 1 ? styles.activeTab : styles.InactiveTab
                            }`}
                    >
                        <ItemAndStoreSearchScreen screenName={"Store"} />
                    </TabPanel>
                </TabView>
            </div>
        </div>
    </>);
};